import React from 'react';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

/**
 * Floating action button for the mobile shell.
 * Sits above the bottom nav (h-16 = 64px) with safe-area padding.
 */
export default function MobileFAB({ onClick, label, icon: Icon = Plus }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label || t('common.add')}
      className="md:hidden fixed right-4 z-30 w-14 h-14 rounded-full bg-amber-500 hover:bg-amber-400 active:bg-amber-600 text-black flex items-center justify-center shadow-lg shadow-amber-500/30 transition-colors"
      style={{ bottom: 'calc(64px + env(safe-area-inset-bottom) + 16px)' }}
    >
      <Icon className="w-6 h-6" strokeWidth={2.5} />
    </button>
  );
}
